import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import LiteYoutubeEmbed from 'react-lite-youtube-embed';
import ReactPlayer from 'react-player';
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css';
import './AboutSection.css';
import coworkersImage from '../../images/co-workers.jpg'


export default function AboutSection() {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);


  const whatYouGetData = [
    "Full Social Media Management",
		"Growth Strategies (organic + paid)",
		"Page Optimization & Setup",
		"Graphic & Video Content Creation",
		"Meta Verification",
		"Google Business Profile Setup",
		"Web Design & SEO",
		"Direct Access to Digital Talents",
		"Sponsored Ads on Meta, TikTok, Snapchat & Google",
  ]

  return (
    <div className='AboutSection'>
      <div className='container'>
        <div className='content' data-aos="fade-up">
          <h1 className='title header-1'>
            We're Not Just a Marketing Agency—We're Your Digital Growth Partner
          </h1>
          <p>
            Whether you're starting from scratch or scaling up, we'll walk you through the strategy, build the structure, and execute with creative precision.
          </p>
          <div className='details'>
            {
              whatYouGetData.map((each, id) => {
                return (
                  <aside data-aos="fade-up" data-aos-delay={`${id}00`} key={id}> 
                    <p>
                      <svg className="Services-check" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="goldenrod" strokeWidth="3">
                        <polyline points="20 6 9 17 4 12"></polyline>
                      </svg>
                      {each} 
                    </p>
                  </aside>
                )
              })
            }
          </div>
        </div>

        <div className='video' data-aos="fade-up">
          <ReactPlayer url="https://www.youtube.com/watch?v=nLb2_z5EVK0" width="100%"/>
          {/* <img src={coworkersImage} alt="oma media" /> */}
        </div>
      </div>
    </div>
  )
}
